import { BannerFieldsFragment } from '../../../@types/generated';
import BannerEdge from './Edge';
import HeroHomePage from './HeroHomePage';
import HeroSubPage from './HeroSubPage';

type Props = {
  data: BannerFieldsFragment;
  priority?: boolean;
};

const index = ({ data, priority }: Props) => {
  if (data.variant === 'edge') {
    return <BannerEdge data={data} />;
  } else if (data.variant === 'heroHomePage') {
    return <HeroHomePage data={data} priority={priority} />;
  } else if (data.variant === 'heroSubPage') {
    return <HeroSubPage data={data} priority={priority} />;
  }
  return;
};
export default index;
